import type { Portal, TourDefinition, TourId } from '../types';
import { T01 } from './orientation/T01';
import { T10 } from './orientation/T10';
import { T12 } from './orientation/T12';
import { TASK_TOURS } from './tasks';

/**
 * The guide catalogue (brief §7): a finite set of local definitions — never a
 * remotely supplied selector or script. Each is filtered per person by
 * `eligibility.ts` from the same permission hooks the UI uses.
 *
 * The orientations (T01, T10, T12) are W1's; the task guides are W6's, in
 * `./tasks`, after the P1 checkpoint.
 */
export const CATALOGUE: readonly TourDefinition[] = [T01, T10, T12, ...TASK_TOURS];

/** Each portal's orientation — what the first-visit invitation offers. */
export const ORIENTATION: Record<Portal, TourId> = {
  tenant: 'T01',
  vendor: 'T10',
  platform: 'T12',
};

export function tourById(id: TourId): TourDefinition | undefined {
  return CATALOGUE.find((tour) => tour.id === id);
}
